<template>
  <div class="loading-content">
    <div class="loading-icon"></div>
    <div class="loading-text">{{ text }}</div>
  </div>
</template>
<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    text: string
  }>(),
  {
    text: '加载中...'
  }
)
</script>
<style lang="scss" scoped>
.loading-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: #101729;
  background-color: #fff;
  border-radius: 4px;
}

.loading-icon {
  display: inline-block;
  background-image: url('@/assets/icons/loading.gif');
  background-size: contain;
  background-repeat: no-repeat;
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
</style>
